// extracted by mini-css-extract-plugin
export default {"card":"MyAccount_card__bnUOt","admin":"MyAccount_admin__Sm+hH"};